import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

const HEADER = 72;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const y = id === "top" ? 0 : el.getBoundingClientRect().top + window.scrollY - HEADER;
  if (window.__lenis) { window.__lenis.resize(); window.__lenis.scrollTo(y); }
  else window.scrollTo({ top: y });
};

export const SmoothScroll = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="#"]');
      if (!a || a.getAttribute("href").length < 2) return;
      e.preventDefault();
      const id = a.getAttribute("href").slice(1);
      requestAnimationFrame(() => scrollToId(id));
    };
    document.addEventListener("click", onClick);
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return () => document.removeEventListener("click", onClick);
    }
    const lenis = new Lenis({ duration: 1.1 });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) { lenis.raf(t); raf = requestAnimationFrame(loop); });
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null;
    };
  }, []);
  return null;
};
